/* THBC main.js — vanilla JS only (jQuery removed Oct 2026).
   Each feature is isolated and guarded so one failure can never break the others.
   NAV CODE RUNS FIRST — keep it at the top of this file. */

/* 1. Desktop nav: open dropdowns on hover */
(function () {
  var menu = document.querySelector('.header__inline-menu');
  if (!menu) return;
  menu.querySelectorAll('details').forEach(function (item) {
    item.addEventListener('mouseover', function () {
      item.setAttribute('open', true);
      var ul = item.querySelector('ul');
      if (ul) {
        ul.addEventListener('mouseleave', function () {
          item.removeAttribute('open');
        });
      }
      item.addEventListener('mouseleave', function () {
        item.removeAttribute('open');
      });
    });
  });
})();

/* 2. Variant plus/minus toggle buttons */
(function () {
  Array.prototype.forEach.call(document.getElementsByClassName('plus-btn'), function (element) {
    element.addEventListener('click', function () {
      var target = document.getElementById(this.dataset.id);
      if (target) {
        target.classList.toggle('active');
        this.innerText = this.innerText.trim() == '+' ? '-' : '+';
      }
    });
  });
})();

/* 3. Color variant label */
document.addEventListener('DOMContentLoaded', function () {
  var radios = document.querySelectorAll("input[type='radio'][name='Color']");
  radios.forEach(function (radio) {
    radio.addEventListener('click', function () {
      var checked = document.querySelector("input[name='Color']:checked");
      var label = document.querySelector('.var_label_info');
      if (checked && label) {
        label.textContent = checked.value;
      }
    });
  });
});

/* 4. Video section: hide title overlay on play */
(function () {
  var media = document.querySelector('.video-section__media');
  if (!media) return;
  media.addEventListener('click', function () {
    document.querySelectorAll('.title-wrapper').forEach(function (el) {
      el.style.display = 'none';
    });
  });
})();

/* 5. Blog tag filter dropdown */
(function () {
  var filter = document.getElementById('BlogTagFilter');
  if (!filter) return;
  filter.addEventListener('change', function () {
    if (this.value) {
      window.location = this.value;
    }
  });
})();

/* 6. Review slider — CSS scroll-snap fallback (replaces Slick) */
(function () {
  var slider = document.querySelector('.review_slider');
  if (!slider || slider.dataset.thbcScroll) return;
  slider.dataset.thbcScroll = '1';
  slider.style.display = 'flex';
  slider.style.overflowX = 'auto';
  slider.style.gap = '16px';
  slider.style.scrollSnapType = 'x mandatory';
  slider.style.webkitOverflowScrolling = 'touch';
  Array.prototype.forEach.call(slider.children, function (child) {
    child.style.flex = '0 0 32%';
    child.style.minWidth = '260px';
    child.style.scrollSnapAlign = 'start';
  });
  document.querySelectorAll('.slide-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir = btn.classList.contains('arrow-prev') ? -1 : 1;
      slider.scrollBy({ left: dir * slider.clientWidth * 0.8, behavior: 'smooth' });
    });
  });
})();

/* 7. Mobile sticky Add-to-Cart bar (product pages, ≤749px — see matching CSS in
   custom-style-thbc-v2.css). Mirrors the REAL Add to Cart button: clicking the
   sticky button clicks the real one, so variants, sold-out state, and the cart
   drawer all behave exactly as normal.
   IMPORTANT: find the BUTTON first and take its closest form — the page also
   contains a hidden Shopify installments form that posts to /cart/add, and
   grabbing the first such form finds no Add button and kills the bar. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  onReady(function () {
    try {
      var info = document.querySelector('.product__info-wrapper');
      if (!info) return; /* product pages only */
      var realBtn = info.querySelector('.product-form__submit, button[name="add"]');
      if (!realBtn) return;

      var bar = document.createElement('div');
      bar.className = 'thbc-sticky-atc';
      bar.innerHTML = '<span class="thbc-sticky-atc__price"></span>' +
        '<button type="button" class="button thbc-sticky-atc__btn">Add to cart</button>';
      var priceEl = bar.querySelector('.thbc-sticky-atc__price');
      var btn = bar.querySelector('.thbc-sticky-atc__btn');
      var priceBox = info.querySelector('.price');

      function sync() {
        try {
          if (priceBox) {
            var p = priceBox.querySelector('.price-item--last') ||
              priceBox.querySelector('.price-item--sale') ||
              priceBox.querySelector('.price-item--regular');
            if (p) priceEl.textContent = p.textContent.trim();
          }
          var labelSrc = realBtn.querySelector('span') || realBtn;
          var label = labelSrc.textContent.trim();
          if (label) btn.textContent = label;
          btn.disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
        } catch (e) { /* never break the page over the bar */ }
      }
      sync();
      try {
        new MutationObserver(sync).observe(realBtn, { attributes: true, childList: true, subtree: true, characterData: true });
        if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
      } catch (e) {}

      btn.addEventListener('click', function () {
        if (realBtn.disabled) {
          realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          realBtn.click();
        }
      });

      document.body.appendChild(bar);

      var watchTarget = realBtn.closest('.product-form__buttons') || realBtn;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { rootMargin: '0px 0px -10px 0px' }).observe(watchTarget);
      } else {
        bar.classList.add('is-visible');
      }
    } catch (e) { /* bar is optional — never break the page */ }
  });
})();

/* 8. Mobile expandable search (≤749px — see matching CSS in custom-style-thbc-v2.css).
   The search bar collapses behind a magnifier icon injected into the header icon
   row. Tapping toggles the bar and focuses the input. It auto-opens on the search
   results page or whenever the input already holds a query. Tablet (750–989px)
   and desktop keep the always-visible bar. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  onReady(function () {
    try {
      var block = document.querySelector('.mobile-search-header-block');
      var iconsRow = document.querySelector('.header-top-block .header__icons');
      if (!block || !iconsRow) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'thbc-search-toggle';
      btn.setAttribute('aria-label', 'Search');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 19 19" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.73 12.44a6.44 6.44 0 1 1 .71-.71l5.41 5.42a.5.5 0 0 1-.7.7l-5.42-5.41Zm.85-5.07a5.44 5.44 0 1 1-10.88 0 5.44 5.44 0 0 1 10.88 0Z" fill="currentColor"/></svg>';
      iconsRow.insertBefore(btn, iconsRow.firstChild);

      var input = block.querySelector('input[type="search"], .search__input, input.field__input');

      function setOpen(open) {
        document.body.classList.toggle('thbc-search-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && input) {
          setTimeout(function () { input.focus(); }, 120);
        }
      }

      btn.addEventListener('click', function () {
        setOpen(!document.body.classList.contains('thbc-search-open'));
      });

      /* Stay open where it makes sense */
      if (location.pathname.indexOf('/search') === 0 || (input && input.value)) {
        document.body.classList.add('thbc-search-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    } catch (e) { /* search stays always-visible if anything fails */ }
  });
})();
